"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author OPt
 */


var WindowImportWindowIdentificationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowImportWindowIdentificationConverter, _DataObjectConverter_);

  function WindowImportWindowIdentificationConverter() {
    _classCallCheck(this, WindowImportWindowIdentificationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowImportWindowIdentificationConverter).apply(this, arguments));
  }

  return WindowImportWindowIdentificationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowImportWindowIdentificationConverter = WindowImportWindowIdentificationConverter;